import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { QRCodeCanvas } from "qrcode.react";
import { useNavigate, Navigate } from "react-router-dom";
import GuestLayout from "../../Layouts/GuestLayout";

export default function Setup2FA() {
  const { user, generate2FASecret, enable2FA } = useAuth();
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill("")); // Six empty slots for OTP
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
console.log(user);
  // if (user && !user.two_factor_enabled && !user.two_factor_verified) {
  //   return <Navigate to="/verify-2fa" replace />;
  // }

  useEffect(() => {
    const fetchQRCode = async () => {
      try {
        const { qr_code_url } = await generate2FASecret();
        setQrCodeUrl(qr_code_url);
      } catch (err) {
        setError(
          "Αποτυχία δημιουργίας QR Code έλεγχος ταυτότητας δύο παραγόντων. Δοκιμάστε ξανά."
        );
      }
    };

    if (user.two_factor_enabled && user.two_factor_verified) {
      navigate('/', { replace: true });
    } else if (!user.two_factor_enabled && !user.two_factor_verified) {
      fetchQRCode();
    } else {
      return;
    }

  }, [generate2FASecret]);

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    if (value) {
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input if available
      if (index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    } else {
      // Clear the current field and move to the previous input
      newOtp[index] = "";
      setOtp(newOtp);

      if (index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };

  const handleEnable2FA = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const otpValue = otp.join(""); // Combine OTP array into a single string
    try {
      await enable2FA(otpValue);
      setSuccess("Ο έλεγχος ταυτότητας δύο παραγόντων είναι πλέον ενεργοποιημένος.");
      navigate('/', { replace: true });
    } catch (err) {
      setError("Μη έγκυρο OTP. Δοκιμάστε ξανά.");
    }
  };

  return (
    <GuestLayout>
      <div className="flex flex-col items-center justify-center h-screen">
        <div className="w-full max-w-md bg-white p-6 rounded shadow-md text-center">
          <h1 className="text-2xl mb-4">Ρύθμιση ελέγχου ταυτότητας δύο παραγόντων</h1>
          {error && <div className="text-red-500 mb-4">{error}</div>}
          {success && <div className="text-green-500 mb-4">{success}</div>}

          <p className="mb-4">
            Για να ρυθμίσετε τον έλεγχο ταυτότητας δύο παραγόντων:
          </p>
          <ol className="list-decimal list-inside mb-4 text-left">
            <li>
              Κατεβάστε την εφαρμογή {" "}
              <a
                href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline"
              >
                Google Authenticator (Android)
              </a>{" "}
              ή {" "}
              <a
                href="https://apps.apple.com/us/app/google-authenticator/id388497605"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline"
              >
                Google Authenticator (iOS)
              </a>.
            </li>
            <li>Ανοίξτε την εφαρμογή και επιλέξτε "Σάρωση QR κώδικα".</li>
            <li>Σαρώστε τον παρακάτω κωδικό QR.</li>
            <li>Εισαγάγετε τον 6-ψήφιο κωδικό που εμφανίζεται στην εφαρμογή.</li>
          </ol>

          {qrCodeUrl && (
            <div className="flex justify-center mb-4">
              <QRCodeCanvas value={qrCodeUrl} size={200} includeMargin={true} />
            </div>
          )}

          <form onSubmit={handleEnable2FA} className="mt-4">
            <div className="flex justify-center gap-2 mb-4">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleChange(e.target.value, index)}
                  className="w-12 h-12 text-center border rounded text-lg"
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" && !otp[index] && index > 0) {
                      document.getElementById(`otp-input-${index - 1}`).focus();
                    }
                  }}
                />
              ))}
            </div>
            <button
              type="submit"
              className="w-full bg-green-500 text-white py-2 rounded hover:bg-green-600 transition mb-2"
            >
              Ενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων
            </button>
          </form>
        </div>
      </div>
    </GuestLayout>
  );
}
